import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    text: 'Pasé de semanas vacías a tener la agenda llena.',
    name: 'Martín López',
    age: 34,
    location: 'Buenos Aires, Argentina'
  }, {
    text: 'Por fin pude subir mis precios sin perder alumnos.',
    name: 'Carlos Ramírez',
    age: 29,
    location: 'Madrid, España'
  }, {
    text: 'Ahora no dependo del boca a boca ni me estreso por cancelaciones.',
    name: 'Diego Fernández',
    age: 41,
    location: 'Montevideo, Uruguay'
  }, {
    text: 'En 3 semanas ya tenía más alumnos que en los últimos 6 meses.',
    name: 'Andrés Morales',
    age: 37,
    location: 'Santiago, Chile'
  }, {
    text: 'El mejor recurso que he encontrado para profesionalizar mis clases.',
    name: 'Roberto Sánchez',
    age: 32,
    location: 'Lima, Perú'
  }];
  return <motion.section initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} viewport={{
    once: true
  }} className="py-16 px-4 bg-card/30" data-id="element-168">
      <div className="max-w-6xl mx-auto" data-id="element-169">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-170">
          Lo que otros profesores ya están logrando
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-171">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-dark border border-primary/20 rounded-lg p-6 hover:border-primary/50 transition-colors" data-id="element-172">
              <div className="flex gap-1 mb-4" data-id="element-173">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-accent text-accent" data-id="element-174" />)}
              </div>

              <QuoteIcon className="w-8 h-8 text-accent/30 mb-3" data-id="element-175" />

              <p className="text-lg mb-4 italic" data-id="element-176">"{testimonial.text}"</p>

              <div className="border-t border-gray-700 pt-4" data-id="element-177">
                <p className="font-bold" data-id="element-178">{testimonial.name}</p>
                <p className="text-sm text-gray-400" data-id="element-179">
                  {testimonial.age} años • {testimonial.location}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </motion.section>;
}